export default `
# Annex 2: Shipping considerations

## Law 39/2015 second attempt rule

For \`NT2\`, the second delivery attempt must be on a different date within the following 3 days and in a different delivery shift. If the first attempt was before 15:00, the second one must be after 15:00, and vice versa. In all cases, there must be at least 3 hours between attempts.

## Ceuta, Melilla and Canary Islands

Shipments to the Canary Islands, Ceuta and Melilla may be subject to customs inspection while in transit. The shipping product and delivery arrangements may vary depending on the destination and applicable conditions.
`



// WEBPACK FOOTER //
// ./src/components/docs/api/content/shippingConsiderations.js